import { Quote, Star } from "lucide-react";
import { Reveal } from "./motion";

const QUOTES = [
  {
    quote: "Tips were a mess on our old platform — now they flow through payroll correctly and our accountant claimed the FICA tip credit for the first time. That credit alone covers the payroll fee many times over.",
    name: "Maria G.",
    role: "Owner, Tex-Mex restaurant group",
    detail: "Dallas–Fort Worth, TX",
  },
  {
    quote: "We hired remote engineers in four new states last year. ABSLpay registered every account and the filings just happened. Our last provider wanted a surcharge per state and still missed a deadline.",
    name: "Daniel K.",
    role: "Founder, IT consulting firm",
    detail: "Remote team across 6 states",
  },
  {
    quote: "Switching mid-year scared me, but they imported the year-to-date numbers, matched our first run to the old provider line by line, and the W-2s came out as one clean form per employee.",
    name: "Priya S.",
    role: "Practice manager, dental clinic",
    detail: "Moved from Gusto in Q3",
  },
];

export const Testimonials = ({ eyebrow = "Client stories" }) => (
  <section className="bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.15em] text-emerald-700">{eyebrow}</p>
        <h2 className="mt-3 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
          What clients say after switching
        </h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {QUOTES.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="h-full flex flex-col rounded-2xl border border-slate-200 bg-[#FAFAFA] p-7 transition-colors hover:border-emerald-300"
            >
              <Quote size={22} className="text-emerald-600" aria-hidden="true" />
              <div className="mt-3 flex gap-0.5" aria-label="5 out of 5 stars">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={13} className="fill-amber-400 text-amber-400" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-700">“{t.quote}”</blockquote>
              <figcaption className="mt-5 border-t border-slate-200 pt-4">
                <span className="block font-display text-sm font-bold text-slate-900">{t.name}</span>
                <span className="block text-xs text-slate-500">{t.role}</span>
                <span className="block text-xs text-emerald-700 font-semibold mt-0.5">{t.detail}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
